import template from './pin-validation.html';

export class PinValidationController {
  constructor($log, moment, PinCodeService) {
    'ngInject';
    this.$log = $log;
    this.moment = moment;
    this.PinCodeService = PinCodeService;

    this.errorMessage = '';
  }

  $onInit() {
    this.headerTitle = `${this.student.lastName} ${this.student.firstName}`;
  }

  validate(form) {
    if (form.$invalid) {
      return;
    }

    this.PinCodeService.hasValidPinCode(this.student.studentUserId, {
      usabilityDay: this.moment().format('YYYY-MM-DD'),
      pinCode: this.pinCode
    })
      .then(({isValid, reason, payload}) => {
        if (isValid) {
          this.onSuccessValidation({result: payload});
          this.nextStep();
        } else {
          this.errorMessage = reason;
        }
      })
      .catch(() => this.closeDialog());
  }
}

export const PinValidation = {
  bindings: {
    headerTitle: '=',
    student: '<',
    nextStep: '&',
    closeDialog: '&',
    onSuccessValidation: '&'
  },
  controller: PinValidationController,
  template
};
